import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TreeLikeFlatNode } from '@src/suite/common/data-models/search-results/search-results';

export const ListActions = createActionGroup({
    source: 'List',
    events: {
        'Set List Guids': props<{ listGuids: Set<string> }>(),
        'Add List Guids': props<{ listGuids: Array<string> }>(),
        'Add new List Guids': props<{ listGuids: Array<string> }>(),
        'Remove List Guids': props<{ listGuids: Array<string> }>(),
        'Clear new List Guids': emptyProps(),
        'Change Node Expanded State': props<{ nodeUuid: string; isExpanded: boolean }>(),
        'Change All Nodes Expanded State': props<{ expanderNodes: TreeLikeFlatNode<unknown>[]; isExpanded: boolean }>(),
        'Reset Node Expanded State': emptyProps(),
        'Navigate Object': props<{ nodeUuid: string }>(),
        'Start Polling': emptyProps(),
        'Stop Polling': emptyProps(),
        'Set Loading': props<{ isLoading: boolean }>(),
    },
});
